module.exports = __webpack_public_path__ + "img/certificate.a2633566.png";